import { render, staticRenderFns } from "./ManualRkiModal.vue?vue&type=template&id=f730b130&"
import script from "./ManualRkiModal.vue?vue&type=script&lang=js&"
export * from "./ManualRkiModal.vue?vue&type=script&lang=js&"
import style0 from "./ManualRkiModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports